"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = _interopRequireDefault(require("lodash.isempty"));
var _lodash2 = _interopRequireDefault(require("lodash.orderby"));
var _warn = _interopRequireDefault(require("./utils/warn"));
var _localstorage = _interopRequireDefault(require("./utils/localstorage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint no-console:0 */ /**
 * Module that provides the `VideoCache` class.
 *
 * @module VideoCache
 */
var LOCALSTORAGE_QUALITY_KEY = 'videoplayback.lastPlayedQuality';
var DEFAULT_FRAGMENT_COUNT = 3;
var DEFAULT_QUALITY = 356; // LD
var QUALITY = {
  'ld': 356,
  'sd': 480,
  'hd': 720,
  // default to 720p for HD
  '4k': 2160,
  '356': 356,
  '480': 480,
  '720': 720,
  '1080': 1080,
  '2160': 2160
};
var M3U8_REGEX = /\w+?(_(\d+))?\.m3u8(\?v=.*)?/gm;
var TS_REGEX = /^\w+\.ts$/gm;
var RESOLUTION_REGEX = /RESOLUTION=(\d+)x(\d+)$/gm;
var BANDWIDTH_REGEX = /BANDWIDTH=(\d+)/gm;

/**
 * Video Cache class that provides an API to load manifest and fragment files
 * of a given video into the browser cache.
 *
 * @example
 * import { VideoCache } from 'hudl-video-playback';
 *
 * let videoCache = new VideoCache([
 *   {
 *     src: 'path/to/video1.m3u8',
 *     fragments: 3,
 *     quality: 'HD',
 *   },
 *   {
 *     src: 'path/to/video2.m3u8',
 *     fragments: 1,
 *   },
 * ]);
 *
 * videoCache.cache();
 */
var VideoCache = exports["default"] = /*#__PURE__*/function () {
  /**
   * Create an instance of a VideoCache.
   * @param {VideoCacheConfig} videoCacheConfig - a list of video sources, with optional parameters per video
   */
  function VideoCache(videoCacheConfig) {
    _classCallCheck(this, VideoCache);
    /** @ignore */
    this._videos = null;
    /** @ignore */
    this._quality = null;
    /** @ignore */
    this._manifestDetails = {};
    if (typeof videoCacheConfig === 'undefined') {
      this._videos = [];
      (0, _warn["default"])('VideoCache.constructor :: No videoCacheConfig parameter given');
    } else if (Array.isArray(videoCacheConfig)) {
      this._videos = videoCacheConfig;
    } else {
      this._videos = [videoCacheConfig];
    }

    // Reset regexp match index
    M3U8_REGEX.lastIndex = 0;
    BANDWIDTH_REGEX.lastIndex = 0;
    RESOLUTION_REGEX.lastIndex = 0;
  }

  /**
   * Convert a quality string to its equivalent resolution height
   * @param {string} quality - the quality string
   * @private
   */
  return _createClass(VideoCache, [{
    key: "_getQualityResolution",
    value: function _getQualityResolution(quality) {
      if (!quality) {
        return null;
      }
      var q = quality.toLowerCase();
      return q.substr(-1) === 'p' ? QUALITY[q.slice(0, -1)] : QUALITY[q];
    }

    /**
     * Cache the videos that were passed on initialization.
     * @private
     */
  }, {
    key: "_cacheVideos",
    value: function _cacheVideos(quality) {
      var _this = this;
      var q = quality || this._quality;
      this._videos.forEach(function (video) {
        if (M3U8_REGEX.test(video.src)) {
          var qualityToCache = _this._getQualityResolution(video.quality) || q;
          var fragmentsToCache = video.fragments ? video.fragments : DEFAULT_FRAGMENT_COUNT;
          _this._loadManifests(video, qualityToCache, fragmentsToCache);
        }
      });
    }

    /**
     * Cache the supplied values from constructor
     */
  }, {
    key: "cache",
    value: function cache() {
      if (this._videos.length === 0) {
        (0, _warn["default"])('VideoCache.cache :: No videos to cache');
        return;
      }
      if (_localstorage["default"] && _localstorage["default"].hasOwnProperty(LOCALSTORAGE_QUALITY_KEY)) {
        var q = _localstorage["default"].getItem(LOCALSTORAGE_QUALITY_KEY).toString();
        this._quality = QUALITY[q.toLowerCase()];
        this._cacheVideos();
      } else {
        this._calculateQuality(this._videos[0].src, this._cacheVideos.bind(this));
      }
    }

    /**
     * Method to load all manifests from a given video source
     * @private
     */
  }, {
    key: "_getManifestDetails",
    value: function _getManifestDetails(src, callback) {
      var _this2 = this;
      if (this._manifestDetails.hasOwnProperty(src)) {
        if (callback) {
          callback(this._manifestDetails[src]);
        }
        return;
      }
      this._xhrGet(src, function (response) {
        var manifests = [];
        var responseText = response.target.responseText;
        var manifestMatch = null;
        var resolutionMatch = null;
        var bandwidthMatch = null;
        do {
          resolutionMatch = RESOLUTION_REGEX.exec(responseText);
          bandwidthMatch = BANDWIDTH_REGEX.exec(responseText);
          manifestMatch = M3U8_REGEX.exec(responseText);
          if (!(0, _lodash["default"])(manifestMatch) && !(0, _lodash["default"])(bandwidthMatch) && !(0, _lodash["default"])(resolutionMatch)) {
            manifests.push({
              src: manifestMatch[0],
              resolution: Number(resolutionMatch[2]),
              bandwidth: Number(bandwidthMatch[1])
            });
          }
        } while (manifestMatch !== null && bandwidthMatch !== null && resolutionMatch !== null);
        // Store manifest details by bandwidth in descending order
        _this2._manifestDetails[src] = (0, _lodash2["default"])(manifests, function (m) {
          return m.bandwidth;
        }, 'desc');
        if (callback) {
          callback(_this2._manifestDetails[src]);
        }
      });
    }

    /**
     * Method to load all manifests from a given video source
     * @private
     */
  }, {
    key: "_loadManifests",
    value: function _loadManifests(video, qualityToCache, fragmentsToCache) {
      var _this3 = this;
      var url = this._getBaseUrl(video.src);
      var cachedFragments = false;
      this._getManifestDetails(video.src, function (manifests) {
        // loop through manifests and cache the matching quality or lower available
        for (var i = 0, len = manifests.length; i < len; i++) {
          var m = manifests[i];
          if (m.resolution <= qualityToCache && !cachedFragments) {
            _this3._loadManifestAndFragments(url, m, fragmentsToCache);
            cachedFragments = true;
          } else {
            _this3._loadManifestAndFragments(url, m, 0);
          }
        }
      });
    }

    /**
     * Method to fetch a manifest and a given number of fragments
     * @private
     */
  }, {
    key: "_loadManifestAndFragments",
    value: function _loadManifestAndFragments(url, manifestObj, fragmentsToCache) {
      var _this4 = this;
      this._xhrGet(url + manifestObj.src, function (response) {
        if (fragmentsToCache > 0) {
          var fragments = _this4._getFragments(response.target.responseText, fragmentsToCache);
          var _iterator = _createForOfIteratorHelper(fragments),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var fragment = _step.value;
              _this4._xhrGet(url + fragment);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      });
    }

    /**
     * Quality calculator method
     * @private
     */
  }, {
    key: "_calculateQuality",
    value: function _calculateQuality(variantManifest, callback) {
      var _this5 = this;
      var url = this._getBaseUrl(variantManifest);
      this._xhrGet(variantManifest, function (variantResponse) {
        var urn = _this5._getLowestQualityManifest(variantResponse.target.responseText);
        if (typeof urn === 'undefined') {
          _this5._setQuality(DEFAULT_QUALITY);
          return callback(DEFAULT_QUALITY);
        }
        var playlistManifest = url + urn;
        _this5._xhrGet(playlistManifest, function (playlistResponse) {
          var fragments = _this5._getFragments(playlistResponse.target.responseText, 1);
          if (fragments.length === 0) {
            _this5._setQuality(DEFAULT_QUALITY);
            return callback(DEFAULT_QUALITY);
          }
          var fragment = url + fragments[0] + '?d=' + new Date().getTime();
          var qualityTestTime = performance.now();
          _this5._xhrGet(fragment, function (fragmentResponse) {
            var duration = (performance.now() - qualityTestTime) / 1000;
            var bits = fragmentResponse.loaded * 8;
            if (!isNaN(bits)) {
              var bps = parseInt(bits / duration, 10);
              _this5._getManifestDetails(variantManifest, function (manifests) {
                for (var i = 0, len = manifests.length; i < len; i++) {
                  var m = manifests[i];
                  if (bps >= m.bandwidth) {
                    _this5._setQuality(m.resolution);
                    return callback(m.resolution);
                  }
                }
                // If no matching quality found, cache the default one
                _this5._setQuality(DEFAULT_QUALITY);
                return callback(DEFAULT_QUALITY);
              });
            }
          });
          return false;
        });
        return false;
      });
    }

    /**
     * Method to update the quality in the localstorage.
     * @private
     */
  }, {
    key: "_setQuality",
    value: function _setQuality(quality) {
      this._quality = quality;
      if (_localstorage["default"]) {
        _localstorage["default"].setItem(LOCALSTORAGE_QUALITY_KEY, this._quality);
      }
    }

    /**
     * Method to fetch lowest possible quality manifest
     * @private
     */
  }, {
    key: "_getLowestQualityManifest",
    value: function _getLowestQualityManifest(manifest) {
      M3U8_REGEX.lastIndex = 0;
      var urn = [];
      var lowestBitrate = 10000;
      var lowestQualityManifest;
      do {
        urn = M3U8_REGEX.exec(manifest);
        if (urn !== null && urn.length > 0) {
          var bitrate = Number(urn[2]);
          if (bitrate < lowestBitrate) {
            lowestBitrate = bitrate;
            lowestQualityManifest = urn[0];
          }
        }
      } while (urn !== null);
      return lowestQualityManifest;
    }

    /**
     * Method to fetch URLs for defined number of fragments
     * @private
     */
  }, {
    key: "_getFragments",
    value: function _getFragments(manifest, fragmentCount) {
      TS_REGEX.lastIndex = 0;
      var fragments = [];
      var count = fragmentCount;
      var match = [];
      while (count > 0) {
        match = TS_REGEX.exec(manifest);
        if (match !== null && match.length > 0) {
          fragments.push(match[0]);
        }
        count--;
      }
      return fragments;
    }

    /**
     * Extract URL from URI
     * @private
     */
  }, {
    key: "_getBaseUrl",
    value: function _getBaseUrl(url) {
      return url.substring(0, url.lastIndexOf('/')) + '/';
    }

    /**
     * Perform XHR GET request
     * @private
     */
  }, {
    key: "_xhrGet",
    value: function _xhrGet(uri, onLoad) {
      var xhr = new window.XMLHttpRequest();
      xhr.addEventListener('load', onLoad);
      xhr.open('GET', uri);
      xhr.send();
    }
  }]);
}();